<script setup lang="ts">
import { useForwardExpose } from "reka-ui";

defineProps<{
	fixed?: boolean;
	sticky?: boolean;
}>();

const { forwardRef } = useForwardExpose();
</script>

<template>
	<nav
		:ref="forwardRef"
		:class="{
			'navbar min-h-12': true,
			sticky: sticky,
			fixed: fixed,
			'inset-0': sticky || fixed,
		}"
	>
		<slot />
	</nav>
</template>
